import { createAnatomy as m } from "../../anatomy/dist/index.mjs";
import { getRelativePoint as f } from "../../dom-event/dist/index.mjs";
import { createScope as b, queryAll as h } from "../../dom-query/dist/index.mjs";
import { getPercentValue as p, getValuePercent as v, getValueTransformer as l } from "../../../../../../@zag-js/numeric-range/dist/index.mjs";
import { dispatchInputValueEvent as y } from "../../../../../../@zag-js/form-utils/dist/index.mjs";
import { createProps as s } from "../../types/dist/index.mjs";
var I = m("slider").parts(
  "root",
  "label",
  "thumb",
  "valueText",
  "track",
  "range",
  "control",
  "markerGroup",
  "marker"
);
I.build();
function c(e) {
  const t = e[0], r = e[e.length - 1];
  return [t, r];
}
function $(e) {
  const [t, r] = c(e.valuePercent);
  if (e.valuePercent.length === 1) {
    if (e.origin === "center") {
      const n = e.valuePercent[0] < 50, o = n ? `${e.valuePercent[0]}%` : "50%", a = n ? "50%" : `${100 - e.valuePercent[0]}%`;
      return { start: o, end: a };
    }
    return { start: "0%", end: `${100 - r}%` };
  }
  return { start: `${t}%`, end: `${100 - r}%` };
}
function S(e) {
  return e.isVertical ? {
    position: "absolute",
    bottom: "var(--slider-range-start)",
    top: "var(--slider-range-end)"
  } : {
    position: "absolute",
    [e.isRtl ? "right" : "left"]: "var(--slider-range-start)",
    [e.isRtl ? "left" : "right"]: "var(--slider-range-end)"
  };
}
function V(e) {
  const { height: t = 0 } = e.thumbSize ?? {}, r = l([e.min, e.max], [-t / 2, t / 2]);
  return parseFloat(r(e.value).toFixed(2));
}
function E(e) {
  const { width: t = 0 } = e.thumbSize ?? {};
  if (e.isRtl) {
    const n = l([e.max, e.min], [-t / 2, t / 2]);
    return -1 * parseFloat(n(e.value).toFixed(2));
  }
  const r = l([e.min, e.max], [-t / 2, t / 2]);
  return parseFloat(r(e.value).toFixed(2));
}
function P(e, t) {
  if (e.thumbAlignment === "center") return `${t}%`;
  const r = e.isVertical ? V(e) : E(e);
  return `calc(${t}% - ${r}px)`;
}
function u(e) {
  let t = v(e.value, e.min, e.max) * 100;
  return P(e, t);
}
function d(e) {
  let t = "visible";
  return e.thumbAlignment === "contain" && !e.hasMeasuredThumbSize && (t = "hidden"), t;
}
function R(e, t) {
  const r = e.isVertical ? "bottom" : "insetInlineStart";
  return {
    visibility: d(e),
    position: "absolute",
    transform: "var(--slider-thumb-transform)",
    [r]: `var(--slider-thumb-offset-${t})`
  };
}
function T() {
  return {
    touchAction: "none",
    userSelect: "none",
    WebkitUserSelect: "none",
    position: "relative"
  };
}
function k(e) {
  const t = $(e);
  return {
    ...e.value.reduce((n, o, a) => {
      const g = u({ ...e, value: o });
      return { ...n, [`--slider-thumb-offset-${a}`]: g };
    }, {}),
    "--slider-thumb-transform": e.isVertical ? "translateY(50%)" : e.isRtl ? "translateX(50%)" : "translateX(-50%)",
    "--slider-range-start": t.start,
    "--slider-range-end": t.end
  };
}
function A(e, t) {
  return {
    // @ts-expect-error
    visibility: d(e),
    position: "absolute",
    pointerEvents: "none",
    // @ts-expect-error
    [e.isHorizontal ? "insetInlineStart" : "bottom"]: u({ ...e, value: t }),
    translate: "var(--tx) var(--ty)",
    "--tx": e.isHorizontal ? e.isRtl ? "50%" : "-50%" : "0%",
    "--ty": e.isHorizontal ? "0%" : "50%"
  };
}
function C() {
  return {
    userSelect: "none",
    WebkitUserSelect: "none",
    pointerEvents: "none",
    position: "relative"
  };
}
var F = {
  getRootStyle: k,
  getControlStyle: T,
  getThumbStyle: R,
  getRangeStyle: S,
  getMarkerStyle: A,
  getMarkerGroupStyle: C
}, i = b({
  ...F,
  getRootId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.root) ?? `slider:${e.id}`;
  },
  getThumbId: (e, t) => {
    var r, n;
    return ((n = (r = e.ids) == null ? void 0 : r.thumb) == null ? void 0 : n.call(r, t)) ?? `slider:${e.id}:thumb:${t}`;
  },
  getHiddenInputId: (e, t) => {
    var r, n;
    return ((n = (r = e.ids) == null ? void 0 : r.hiddenInput) == null ? void 0 : n.call(r, t)) ?? `slider:${e.id}:input:${t}`;
  },
  getControlId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.control) ?? `slider:${e.id}:control`;
  },
  getTrackId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.track) ?? `slider:${e.id}:track`;
  },
  getRangeId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.range) ?? `slider:${e.id}:range`;
  },
  getLabelId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.label) ?? `slider:${e.id}:label`;
  },
  getValueTextId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.valueText) ?? `slider:${e.id}:value-text`;
  },
  getMarkerId: (e, t) => {
    var r, n;
    return ((n = (r = e.ids) == null ? void 0 : r.marker) == null ? void 0 : n.call(r, t)) ?? `slider:${e.id}:marker:${t}`;
  },
  getRootEl: (e) => i.getById(e, i.getRootId(e)),
  getThumbEl: (e, t) => i.getById(e, i.getThumbId(e, t)),
  getHiddenInputEl: (e, t) => i.getById(e, i.getHiddenInputId(e, t)),
  getControlEl: (e) => i.getById(e, i.getControlId(e)),
  getElements: (e) => h(i.getControlEl(e), "[role=slider]"),
  getFirstEl: (e) => i.getElements(e)[0],
  getRangeEl: (e) => i.getById(e, i.getRangeId(e)),
  getValueFromPoint(e, t) {
    const r = i.getControlEl(e);
    if (!r) return;
    const o = f(t, r).getPercentValue({
      orientation: e.orientation,
      dir: e.dir,
      inverted: { y: !0 }
    });
    return p(o, e.min, e.max, e.step);
  },
  dispatchChangeEvent(e) {
    Array.from(e.value).forEach((r, n) => {
      const o = i.getHiddenInputEl(e, n);
      o && y(o, { value: r });
    });
  }
});
s()([
  "aria-label",
  "aria-labelledby",
  "dir",
  "disabled",
  "form",
  "getAriaValueText",
  "getRootNode",
  "id",
  "ids",
  "invalid",
  "max",
  "min",
  "minStepsBetweenThumbs",
  "name",
  "onFocusChange",
  "onValueChange",
  "onValueChangeEnd",
  "orientation",
  "origin",
  "readOnly",
  "step",
  "thumbAlignment",
  "thumbAlignment",
  "thumbSize",
  "value"
]);
s()(["index", "name"]);
export {
  I as anatomy
};
